import { FC } from 'react';

import { keys } from 'app/config/keys';
import { PropsWithOnlyChildren } from 'app/types';

import BeamerProvider from './BeamerProvider';
import FreshChatProvider from './FreshChatProvider';
import FullStoryProvider from './FullStoryProvider';
import MedalliaProvider from './MedalliaProvider';
import PendoProvider from './PendoProvider';

// Component Definition
const ThirdPartyProviders: FC<PropsWithOnlyChildren> = ({ children }) => {
  // Disable all third-party providers in local development
  if (keys.__DEV__ || keys.NODE_ENV === 'test') {
    console.info('[ThirdPartyProviders] All third-party services disabled in local development');

    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {children}
      </>
    );
  }

  return (
    <MedalliaProvider>
      <FreshChatProvider>
        <BeamerProvider>
          <FullStoryProvider>
            <PendoProvider>
              {children}
            </PendoProvider>
          </FullStoryProvider>
        </BeamerProvider>
      </FreshChatProvider>
    </MedalliaProvider>
  );
};

export default ThirdPartyProviders;
